import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep } from "lodash";
import draggable from "vuedraggable";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BoardsDropdown",
  components: {
    draggable
  },
  props: {
    boards: {
      type: Array,
      required: true
    },
    boardId: {
      type: [String, Number],
      default: ""
    },
    create: {
      type: Boolean,
      default: false
    },
    order: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nonce: 0
    };
  },
  computed: {
    orderedBoards: {
      get() {
        var _context;
        const boards = _sortInstanceProperty(_context = cloneDeep(this.boards)).call(_context, (a, b) => _parseInt(a == null ? void 0 : a.boardOrder) - _parseInt(b == null ? void 0 : b.boardOrder));
        return boards;
      },
      set(value) {
        this.nonce++;
        this.$emit("order", _mapInstanceProperty(value).call(value, (board, index) => _objectSpread(_objectSpread({}, board), {}, {
          boardOrder: index + 1
        })));
      }
    }
  },
  methods: {
    handleClick(boardId, event) {
      this.$emit("select", event, {
        boardId
      });
    },
    handleCreateClick() {
      this.$emit("create");
    }
  }
});